import { render, staticRenderFns } from "./PatientOriginalAvatarView.vue?vue&type=template&id=54b19405&"
import script from "./PatientOriginalAvatarView.vue?vue&type=script&lang=js&"
export * from "./PatientOriginalAvatarView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports